<script lang="ts" setup>
//===============================================
//                   Imports
//===============================================
import { ref } from "vue"
import { useI18n } from "vue-i18n"
import { useEmConsoCompareStore } from "@modules/energy-manager/stores/em-conso-compare.store"

//===============================================
//                  Variables
//===============================================
const emConsoCompareStore = useEmConsoCompareStore()
const options = ref(["Carte", "Liste"])
const optionValue = ref<string>(options.value[0])

//===============================================
//                    Lang
//===============================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Mes bâtiments",
            subTitle: " bâtiments",
        },
    },
})
</script>
<template>
    <BaseCard class="card-building" id="card-building">
        <template #header>
            <div class="card-building__header">
                <div class="card-building__header-titles">
                    <h1 class="font-bold text-primary-700 text-xl">
                        {{ t("title") }}
                    </h1>
                    <span class="text-xs">&#9679;</span>
                    <p class="text-primary-700">
                        {{
                            emConsoCompareStore.compareListId.length +
                            t("subTitle")
                        }}
                    </p>
                </div>
                <div class="card-building__header-inputs">
                    <div id="card-building-search"></div>

                    <BaseSelectButton
                        v-model="optionValue"
                        :options="options"
                        :default-value="options[0]"
                        :allow-empty="false"
                    />
                </div>
            </div>
        </template>
        <template #content>
            <ListBuilding v-if="optionValue === 'Liste'"></ListBuilding>
            <MapBuilding v-else></MapBuilding>
        </template>
    </BaseCard>
</template>
<style scoped>
.card-building {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    padding: 1.5rem;
    border-width: 1px;
    --p-card-shadow: none;
    --p-card-body-padding: none !important;
}
.card-building__header {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;

    .card-building__header-titles {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.25rem;
    }

    .card-building__header-inputs {
        display: flex;
        flex-direction: row;
        gap: 0.5rem;
        margin-left: auto;
    }
}

.card-building__list-column {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}
</style>
